import { render, staticRenderFns } from "./default-text-field.vue?vue&type=template&id=159cdee3"
import script from "./default-text-field.vue?vue&type=script&lang=js"
export * from "./default-text-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports